import axios from "axios";
import authAPI from "@/api/auth";
import VueJwtDecode from "vue-jwt-decode";

const allowedUserRoles = ["ROLE_BUILDING_OWNER", "ROLE_MEETING_GUEST", "ROLE_MEETING_CONTACT"];
const userNotAllowedMessage = "THIS APP IS FOR BUILDING OWNERS NOT FOR AGENCYES!";

function checkIfUserAllowed(token) {
  var userRoles = VueJwtDecode.decode(token).roles;
  return userRoles.some(role => {
    return allowedUserRoles.includes(role);
  });
}

const auth = {
  namespaced: true,
  state: {
    token: localStorage.getItem("token") || "",
    mercureJwtToken: localStorage.getItem("mercure-jwt-token") || "",
    anotherRefreshTokenOngoing: false,
  },
  getters: {
    isAuthenticated(state) {
      return !!state.token;
    },
    mercureJwtToken(state) {
      return state.mercureJwtToken;
    },
    isAuthenticatedForMercure(state) {
      return !!state.mercureJwtToken;
    },
    isAnotherRefreshTokenOngoing(state) {
      return state.anotherRefreshTokenOngoing;
    },
  },
  mutations: {
    auth(state, tokens) {
      var decodedToken = VueJwtDecode.decode(tokens.token);

      state.token = tokens.token;
      state.mercureJwtToken = decodedToken.mercureJwtToken;

      localStorage.setItem("token", tokens.token);
      localStorage.setItem("refresh_token", tokens.refreshToken);
      localStorage.setItem("mercure-jwt-token", decodedToken.mercureJwtToken);
      localStorage.setItem("userId", decodedToken.userId);
      localStorage.setItem("username", decodedToken.username);
      localStorage.setItem("email", decodedToken.email ? decodedToken.email : "");
      localStorage.setItem("roles", decodedToken.roles);
      localStorage.setItem("agencyId", decodedToken.agencyId);

      axios.defaults.headers.common["Authorization"] = "Bearer " + tokens.token;
    },
    deauth(state) {
      // clear store data on deauth
      this.dispatch("entities/deleteAll");

      state.token = "";
      state.mercureJwtToken = "";

      localStorage.removeItem("token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("mercure-jwt-token");
      localStorage.removeItem("userId");
      localStorage.removeItem("username");
      localStorage.removeItem("email");
      localStorage.removeItem("agencyId");
      localStorage.removeItem("roles");
      localStorage.removeItem("building_id");
      localStorage.removeItem("building_owner_id");
      localStorage.removeItem("meeting_guest_id");
      localStorage.removeItem("contact_id");

      delete axios.defaults.headers.common["Authorization"];
    },
    logout(state) {
      state.token = "";
    },
    set_another_refresh_token_ongoing(state, value) {
      state.anotherRefreshTokenOngoing = value;
    },
  },
  actions: {
    login({ commit }, loginData) {
      return new Promise((resolve, reject) => {
        authAPI
          .login(loginData)
          .then(res => {
            if (!checkIfUserAllowed(res.data.token)) {
              reject(userNotAllowedMessage);
            } else {
              const tokens = {
                token: res.data.token,
                refreshToken: res.data.refresh_token,
              };
              commit("auth", tokens);
              resolve(res);
            }
          })
          .catch(err => {
            commit("deauth");
            reject(err);
          });
      });
    },
    logout({ commit }) {
      return new Promise((resolve, reject) => {
        commit("deauth");
        resolve();
      });
    },
    tokenRefresh({ commit, getters }) {
      const anotherRefreshTokenOngoing = getters.isAnotherRefreshTokenOngoing;
      if (!anotherRefreshTokenOngoing) {
        commit("set_another_refresh_token_ongoing", true);
        return new Promise((resolve, reject) => {
          authAPI
            .tokenRefresh()
            .then(res => {
              if (!checkIfUserAllowed(res.data.token)) {
                reject(userNotAllowedMessage);
              } else {
                const tokens = {
                  token: res.data.token,
                  refreshToken: res.data.refresh_token,
                };
                commit("auth", tokens);
                commit("set_another_refresh_token_ongoing", false);

                resolve(res);
              }
            })
            .catch(err => {
              commit("deauth");
              commit("set_another_refresh_token_ongoing", false);

              reject(err);
            });
        });
      }
    },
    /** FORGOT PASSWORD */
    async checkEmail({ commit }, email) {
      return new Promise((resolve, reject) => {
        authAPI
          .checkEmail(email)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            console.error(err);
            reject(err);
          });
      });
    },
    async checkUsername({ commit }, username) {
      return new Promise((resolve, reject) => {
        authAPI
          .checkUsername(username)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            console.error(err);
            reject(err);
          });
      });
    },
    checkVerificationCode({ commit }, verificationCode) {
      return new Promise((resolve, reject) => {
        authAPI
          .checkVerificationCode(verificationCode)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            console.error(err);
            reject(err);
          });
      });
    },
    setPassword({ commit }, payload) {
      return new Promise((resolve, reject) => {
        authAPI
          .setPassword(payload.verificationCode, payload.password)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            console.error(err);
            reject(err);
          });
      });
    },
  },
};

export default auth;
